const reasons = {
    polite: [
      {
        zhHans: "我身体不适，今天无法上班。",
        zhHant: "我身體不適，今天無法上班。",
        en: "I'm feeling unwell and can't work today.",
        ms: "Saya tidak sihat dan tidak dapat bekerja。",
      },
      {
        zhHans: "我家人今天有突发状况，需要我处理。",
        zhHant: "我家人今天有突發狀況，需要我處理。",
        en: "There’s an emergency at home. I need to take care of it.",
        ms: "Ada kecemasan di rumah. Saya perlu uruskannya。",
      },
      {
        zhHans: "我今天需要陪妈妈去体检，比较放心。",
        zhHant: "我今天需要陪媽媽去體檢，會比較安心。",
        en: "I need to accompany my mother for a medical check-up today. It gives us peace of mind.",
        ms: "Saya perlu temankan ibu saya untuk pemeriksaan kesihatan hari ini. Boleh lebih tenang。",
      },
      {
        zhHans: "家里最近有些琐事需要我处理，今天请个假。",
        zhHant: "家裡最近有些瑣事需要我處理，今天請個假。",
        en: "There are some family matters I need to handle today.",
        ms: "Ada beberapa urusan keluarga yang perlu saya selesaikan hari ini。",
      },
      {
        zhHans: "我今天身体虽然没大碍，但感觉特别沉重，想留在家里恢复一下。",
        zhHant: "我今天身體雖然沒大礙，但感覺特別沉重，想留在家裡恢復一下。",
        en: "I’m not seriously ill, but I feel physically heavy today. I need to stay home to recover.",
        ms: "Saya tak sakit teruk, tapi badan terasa berat hari ini. Saya nak rehat di rumah。",
      }
    ],
    emotional: [
      {
        zhHans: "情绪有点崩，我尽量不打扰别人，今天请个假恢复一下。",
        zhHant: "我今天情緒不穩，請讓我休息。",
        en: "I'm emotionally unwell today. I need to rest.",
        ms: "Saya tidak stabil secara emosi hari ini. Saya perlukan rehat。",
      },
      {
        zhHans: "我今天真的需要一个人的时间来整理思绪。",
        zhHant: "我今天真的需要一個人的時間來整理思緒。",
        en: "I really need some time alone today to clear my thoughts.",
        ms: "Saya perlukan masa bersendirian hari ini untuk tenangkan fikiran。",
      },
      {
        zhHans: "最近压力太大，我担心影响到工作表现，今天想暂时休息一下。",
        zhHant: "最近壓力太大，我擔心影響到工作表現，今天想暫時休息一下。",
        en: "Lately I've been under too much stress and I’m worried it’ll affect my work. I need a short break.",
        ms: "Kebelakangan ini saya terlalu stres dan bimbang ia menjejaskan kerja. Saya perlukan rehat sementara。",
      },
      {
        zhHans: "我朋友遇到一些心理困扰，我需要陪伴她一整天。",
        zhHant: "我朋友遇到一些心理困擾，我需要陪伴她一整天。",
        en: "A friend of mine is going through some mental stress. I need to be there for her today.",
        ms: "Seorang kawan saya sedang menghadapi tekanan emosi. Saya perlu temankannya hari ini。",
      },
      {
        zhHans: "我今天心浮气躁，不想把情绪带进工作，想请个假缓缓。",
        zhHant: "我今天心浮氣躁，不想把情緒帶進工作，想請個假緩緩。",
        en: "I feel emotionally unstable today and don’t want to bring it into the workplace.",
        ms: "Hari ini saya agak tak tenang dan tak mahu bawa emosi ini ke tempat kerja。",
      }
    ],
    absurd: [
      {
        zhHans: "今天我灵魂空洞，需要休息。",
        zhHant: "今天我靈魂空洞，請容我休息。",
        en: "My soul is a hollow shell today. I need rest.",
        ms: "Jiwa saya kosong hari ini. Saya perlukan rehat。",
      },
      {
        zhHans: "我的仓鼠今天有牙套检查，我要陪它去。",
        zhHant: "我的倉鼠今天有牙套檢查，我要陪牠去。",
        en: "My hamster has a dental checkup today. I need to go with him.",
        ms: "Hamster saya ada pemeriksaan gigi hari ini. Saya perlu temankannya。",
      },
      {
        zhHans: "我家的猫昨天梦到我死了，今天很焦虑。我要陪它。",
        zhHant: "我家的貓昨天夢到我死了，今天很焦慮。我要陪牠。",
        en: "My cat dreamed I died last night and is very anxious today. I need to stay with her.",
        ms: "Kucing saya mimpi saya mati malam tadi. Dia sangat cemas. Saya perlu temankannya。",
      },
      {
        zhHans: "我家的乌龟今天看着我发呆一整晚，我觉得它在向我传达什么讯息，我需要静下心来感受。",
        zhHant: "我家的烏龜今天看著我發呆一整晚，我覺得牠在向我傳達什麼訊息，我需要靜下心來感受。",
        en: "My turtle stared at me all night. I think it’s trying to tell me something. I need to stay home and listen.",
        ms: "Kura-kura saya renung saya semalaman. Saya rasa ia sedang cuba sampaikan sesuatu. Saya nak tenangkan diri di rumah。",
      },
      {
        zhHans: "我昨晚梦到自己在上班，但醒来后还是要上班，这种双重打击我需要缓一缓。",
        zhHant: "我昨晚夢到自己在上班，但醒來後還是要上班，這種雙重打擊我需要緩一緩。",
        en: "I dreamed I was working last night. Then I woke up and still had to work. The double trauma needs processing.",
        ms: "Saya bermimpi kerja semalam. Lepas bangun pun masih kena kerja. Saya perlukan masa untuk hadam trauma ini。",
      },
      {
        zhHans: "我今天对窗外的树产生了很深的共鸣，需要一点时间来理解这种情绪。",
        zhHant: "我今天對窗外的樹產生了很深的共鳴，需要一點時間來理解這種情緒。",
        en: "I deeply resonated with a tree outside my window this morning. I need time to understand this feeling.",
        ms: "Saya terasa sangat berkaitan dengan pokok di luar pagi ini. Saya perlukan masa untuk fahami perasaan ini。",
      },
      {
        zhHans: "我的手机今天莫名其妙开始发热，感觉它替我承受了我的压力。我决定也给自己放一天假。",
        zhHant: "我的手機今天莫名其妙開始發熱，感覺它替我承受了我的壓力。我決定也給自己放一天假。",
        en: "My phone overheated mysteriously this morning. I think it's absorbing my stress. I decided to join it and rest.",
        ms: "Telefon saya tiba-tiba panas pagi ini. Mungkin ia sedang serap tekanan saya. Saya pun nak berehat macam dia。",
      },
      {
        zhHans: "我试着鼓励自己去上班，但内心的小剧场拉起了横幅写着“不值得”。",
        zhHant: "我試著鼓勵自己去上班，但內心的小劇場拉起了橫幅寫著「不值得」。",
        en: "I tried to hype myself up for work, but my inner theater unrolled a banner saying 'Not Worth It.'",
        ms: "Saya cuba semangatkan diri untuk kerja, tapi teater dalam hati saya keluarkan sepanduk 'Tak Berbaloi'。",
      },
      {
        zhHans: "今天我像一张被风吹皱的纸，不宜上班。",
        zhHant: "今天我像一張被風吹皺的紙，不宜上班。",
        en: "Today I feel like a wrinkled piece of paper blown by the wind. Not fit for work.",
        ms: "Hari ini saya rasa seperti sekeping kertas yang ditiup angin. Tak sesuai bekerja。",
      }
    ]
  };
  
  export default reasons;